import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { billsSubHeaders } from '../../utils/balance-accounts';
import ItemAccountsRow from './ItemAccountsRow';
//----------------------------------------------------------------
const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
    },
  },
});
//----------------------------------------------------------------
const ItemAccountsTable = ({ data, loading, tableRef }) => {
  const classes = useStyles();

  return (
    <Paper sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center" rowSpan={2}>
                번호
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                아이템명
              </TableCell>
              <TableCell align="center" colSpan={3}>
                매입계산서 실적
              </TableCell>
            </TableRow>
            <TableRow>
              {billsSubHeaders &&
                billsSubHeaders.map((header) => {
                  return (
                    <TableCell key={header?.id} align="center">
                      {header?.name}
                    </TableCell>
                  );
                })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data === null || data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <ItemAccountsRow data={data} keyName="pp" />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default ItemAccountsTable;
